"use strict";
// tslint:disable
// eslint-disable
/**
 * Roles and Rights API
 * API for configurable roles and rights
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
function RightsCategoryFromJSON(json) {
    return RightsCategoryFromJSONTyped(json, false);
}
exports.RightsCategoryFromJSON = RightsCategoryFromJSON;
function RightsCategoryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'translationKey': json['translationKey'],
        'sortOrder': json['sortOrder'],
        'rights': json['rights'].map(_1.SortedRightFromJSON),
    };
}
exports.RightsCategoryFromJSONTyped = RightsCategoryFromJSONTyped;
function RightsCategoryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'translationKey': value.translationKey,
        'sortOrder': value.sortOrder,
        'rights': value.rights.map(_1.SortedRightToJSON),
    };
}
exports.RightsCategoryToJSON = RightsCategoryToJSON;
